/* eslint-disable prefer-template */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import 'typeface-roboto';
import Grid from '@material-ui/core/Grid';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  desktop: {
    width: '50%',
    float: 'left',
    padding: 4,
  },
  smartphone: {
    width: '100%',
    float: 'left',
    padding: 4,
  },
  media: {
    width: '100%',
    minHeight: '152px',
    borderRadius: 10,
  },
  title: {
    color: theme.palette.primary.main,
  },
  image: {
    width: '100%',
    height: 80,
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    minWidth: 80,
    minHeight: 80,
    borderRadius: 10,
  },
  detail: {
    flex: 1,
  },
  title: {
    color: theme.palette.primary.main,
  },
  infoWrapper: {
    height: '100%',
  },
  priceWrapper: {
    height: '100%',
  },
}));

const OlsPostGrid = (props) => {
  const classes = useStyles();
  const { data } = props;

  const isMobileScreen = useMediaQuery({ query: '(max-width: 480px)' });

  /*
  let discountStr = '';
  if (data.post_discount_value > 0) {
    if (data.post_discount_type === 'PERCENTAGE') {
      discountStr = ' %';
    }
  }
  */

  return (
      <div className={isMobileScreen ? classes.smartphone : classes.desktop} >
        <Card>
          <CardActionArea component={Link} to={`/post/${data.post_permalink}`} >
            <CardContent>
              <Grid container spacing={2} justify="space-between">
                <Grid style={data.post_picture ? {} : { display: 'none' }} item>
                  <Grid item>
                  <img alt="" className={classes.image} src={data.post_picture} />
                  </Grid>
                </Grid>
                <Grid item className={classes.detail}>
                  <Grid item container className={classes.infoWrapper} direction="column" justify="center" alignItems="flex-start">
                    <Grid item>
                      <Typography className={classes.title} variant="body1">{data.post_title}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="caption">
                        {data.post_headline}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
        </Card>
      </div>
  );
};

OlsPostGrid.defaultProps = {
  data: {
    post_uxid: '',
    post_permalink: '',
    post_title: '',
    post_headline: '',
    post_picture: '',
    post_content:'',
  },
};

export default OlsPostGrid;
